import request from "@/utils/request";
import { Local } from "@/utils/storage";
// import { Local } from "@/utils/storage";

//重置用户密码
export function resetUserPwd(uid:any){
    let path = "/api/user/resetPwd"
    let param = {
        userId: uid
    }
    return request.post(path,param)
}

//获取用户信息
export function getUserInfo(uid:any){
    let path = "/api/user/getInfo"
    let param = {
        userId: uid
    }
    return request.get(path,param)
}

//资产数据
export function getUserAssets(uid:any){
    let path = "/api/user/assetsCounts"
    let param = {
        userId: uid
    }
    return request.get(path,param)
}

//用户会员卡
export function getUserCards(uid:any){
    let path = "/api/user/member/cards"
    let param = {
        userId: uid
    }
    return request.get(path,param)
}
export function setCarbon(data:any){
    let path = "/api/admin/carbon/balance"

    return request.post(path,data)
}

export function setConsume(data:any){
    let path = "/api/admin/consume/balance"

    return request.post(path,data)
}

export function setInvent(data:any){
    let path = "/api/admin/invent/balance"

    return request.post(path,data)
}

export function getAdminPermissions(){
    let path = "/api/admin/invent/balance"

    return request.post(path,{})
}

export function getFeatureTrialUsage(){
    let path = "/shared/featureTrialUsage/queryUsage"
    let param = {
        chamber_id: Local.get('curChamber').chamber_id
    }
    return request.post(path,param)
}

// 使用功能体验次数
export function useFeatureTrial(data: {
    feature_code: string;
    chamber_id: number;
}) {
    let path = "/shared/featureTrialUsage/useFeature"
    return request.post(path, data)
}

// 获取管理员商会权限
export function getAdminChamberPermissions(data: {
    id: number;
    userId: number;
}) {
    let path = "/shared/shUser/getAdminPermissions"
    return request.get(path, data)
}

// 使用功能体验次数
export function getAdminChamber() {
    let param = {
        id: Local.get('managerInfo').id
    }
    if(!param.id){
        return Promise.reject()
    }
    let path = "/shared/shUser/getAdminChamber"
    return request.get(path, param)
}